const prefix = '@@KANDY/'

export const CONNECT = prefix + 'CONNECT'
export const SET_CONNECTION_INFO = prefix + 'SET_CONNECTION_INFO'
export const CONNECTION_OCCURRED = prefix + 'CONNECTION_OCCURRED'
export const CONNECT_FINISHED = prefix + 'CONNECT_FINISHED'
export const GET_USER_DETAILS = prefix + 'GET_USER_DETAILS'
export const USER_DETAILS_RECEIVED = prefix + 'USER_DETAILS_RECEIVED'
export const DISCONNECT = prefix + 'DISCONNECT'
export const DISCONNECT_FINISHED = prefix + 'DISCONNECT_FINISHED'
export const RESUBSCRIPTION_FINISHED = prefix + 'RESUBSCRIPTION_FINISHED'
export const REFRESH_TOKENS = prefix + 'REFRESH_TOKENS'
export const REFRESH_TOKENS_FINISHED = prefix + 'REFRESH_TOKENS_FINISHED'

export const UPDATE_SUBSCRIPTION = prefix + 'UPDATE_SUBSCRIPTION'
export const UPDATE_SUBSCRIPTION_FINISH = prefix + 'UPDATE_SUBSCRIPTION_FINISH'

export const SET_TOKEN = prefix + 'SET_TOKEN'

export const SET_CREDENTIALS = prefix + 'SET_CREDENTIALS'
export const SET_CREDENTIALS_FINISH = prefix + 'SET_CREDENTIALS_FINISH'

export const AUTHORIZATION_ERROR = prefix + 'AUTHORIZATION_ERROR'

export const UPDATE_HMAC_TOKEN = prefix + 'UPDATE_HMAC_TOKEN'
